// extracted by mini-css-extract-plugin
export default {"landing":"Landing_landing__XiyPB","row":"Landing_row__K-Bah"};